import ButtonMenu from "componentsv2/menu/ButtonMenu";
import { DocumentIcon } from "components/Icons";

function MenuReports({ reports, record }) {
  return (
    <ButtonMenu
      title="Reports"
      type="report"
      record={record}
      values={reports}
      Icon={DocumentIcon}
    />
  );
}

export default MenuReports;
